<template>
    <div>
        <hr>
        <div class="card-body text-center">
            <div class="button-group">
                <button @click="acceptTrade()" class="btn btn-success" type="button">Accept</button>
                <button @click="declineTrade()" class="btn btn-danger" type="button">Decline</button>
            </div>
        </div>
        <div class="card-body">
            <p class="text-center aboutscroll">
                You can accept or decline the trade offer. At this stage, you can continue negotiating with the counterparty. Please read all terms carefully before accepting the trade.
            </p>
        </div>
    </div>
</template>


<script>
    export default {
        name: "Accept",
        props: {
            trade: Object,
            events: Object
        },
        methods: {
            async acceptTrade() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.post('/trades/' + this.trade.trade_id + '/accept', {comments: ''});
                    this.events.$emit('trade:reload');
                    $(".preloader").fadeOut();
                    this.$toastr('success', 'Your acceptance saved successfully.', 'Trade Accepted');
                } catch(e) {
                    $(".preloader").fadeOut();
                    console.log(e);
                    this.$toastr('error', 'Trade acceptance failed', 'Failed');
                }
            },
            async declineTrade() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.post('/trades/' + this.trade.trade_id + '/decline', {comments: ''});
                    this.events.$emit('trade:reload');
                    $(".preloader").fadeOut();
                    this.$toastr('warning', 'You have declined this trade.', 'Trade Declined');
                } catch(e) {
                    $(".preloader").fadeOut();
                    console.log(e);
                    this.$toastr('error', 'Trade declination failed', 'Failed');
                }
            }
        }
    }
</script>

<style scoped>

</style>
